/**
 * Created by olga on 27.02.2023
 */

const VirtualProduct = function (data) {
    Product.call(this, data);
};

VirtualProduct.prototype = Object.create(Product.prototype);
VirtualProduct.prototype.constructor = VirtualProduct;

VirtualProduct.prototype.getCurrentPrice = function () {
    return this.currency === "hard" ? `$$${this.price}` : `@@${this.price}`;
};

VirtualProduct.prototype.getUsdPrice = function () {
    return 0;
};

VirtualProduct.prototype.isAvailable = function () {
    return this.type !== Product.TYPE_ADS || Product.prototype.isAvailable.call(this);
};

VirtualProduct.prototype.buy = function (closeShopCallback, options) {
    if (this.type === Product.TYPE_ADS) {
        Product.prototype.buy.call(this, closeShopCallback, options);
        return;
    }

    options = options || {};

    const spendCurrency = this.currency === "hard" ? levels.user.spendHard : levels.user.spendSoft;
    const spentEventName = this.spentEvent || this.getSpentEventFromContext();

    if (spendCurrency.call(levels.user, spentEventName, this.price)) {
        cleverapps.metrics.logEvent(`${cleverapps.EVENTS.STATS.BUY_VIRTUAL_ITEM}-${spentEventName}`);

        if (this.reward && !options.noRewardWindow) {
            cleverapps.focusManager.display({
                focus: "VirtualProductReward",
                stack: true,
                action: (f) => {
                    new RewardWindow(this.reward, { event: spentEventName });
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            });
        }

        cleverapps.effects.fire("ui.shop.buy");
        closeShopCallback(true);

        return true;
    }

    return false;
};
